// Données de test centralisées pour l'application Provelliance

// Liste des clients
export const clientsData = [
  {
    id: 1,
    raisonSociale: "AXA Assurances",
    secteur: "Assurance",
    adresse: "25 Avenue Matignon, 75008 Paris",
    codePostal: "75008",
    ville: "Paris",
    telephone: "01 40 75 48 48",
    fax: "01 40 75 48 49",
    email: "contact@axa.fr",
    siteWeb: "www.axa.fr",
    siret: "572 093 920 00156",
    numeroTVA: "FR 25 572 093 920",
    nombreDossiers: 45,
    statut: "actif",
    dateCreation: "2023-01-15",
    derniereModification: "2024-03-10",
    contacts: [
      { 
        id: 1,
        nom: "Martin Dubois", 
        poste: "Directeur Sinistres", 
        email: "m.dubois@axa.fr",
        telephone: "01 40 75 48 50",
        mobile: "06 12 34 56 78"
      },
      { 
        id: 2,
        nom: "Sophie Laurent", 
        poste: "Gestionnaire", 
        email: "s.laurent@axa.fr",
        telephone: "01 40 75 48 51",
        mobile: "06 87 65 43 21"
      }
    ],
    historiquesDossiers: [
      {
        id: 101,
        numero: "DOS-2024-001",
        reference: "REF-CLIENT-1245",
        type: "Sinistre Auto",
        dateOuverture: "2024-03-01",
        dateCloture: "2024-03-15",
        statut: "clôturé",
        enqueteur: "Jean Martin",
        montant: "15 000 €"
      },
      {
        id: 102,
        numero: "DOS-2024-012",
        reference: "REF-CLIENT-6498",
        type: "Sinistre Habitation",
        dateOuverture: "2024-03-10",
        dateCloture: null,
        statut: "en cours",
        enqueteur: "Marie Dupont",
        montant: "8 500 €"
      },
      {
        id: 103,
        numero: "DOS-2024-018",
        reference: "REF-CLIENT-6951",
        type: "Sinistre Professionnel",
        dateOuverture: "2024-03-12",
        dateCloture: null,
        statut: "attribué",
        enqueteur: "Pierre Moreau",
        montant: "25 000 €"
      }
    ]
  },
  {
    id: 2,
    raisonSociale: "Allianz France",
    secteur: "Assurance",
    adresse: "87 Rue de Richelieu, 75002 Paris",
    telephone: "01 44 86 20 00",
    email: "info@allianz.fr",
    nombreDossiers: 32,
    statut: "actif",
    dateCreation: "2023-02-08",
    contacts: [
      { nom: "Pierre Moreau", poste: "Responsable Expertise", email: "p.moreau@allianz.fr" }
    ]
  },
  {
    id: 3,
    raisonSociale: "Groupama",
    secteur: "Assurance",
    adresse: "8-10 Rue d'Astorg, 75008 Paris",
    telephone: "01 44 56 77 77",
    email: "contact@groupama.fr",
    nombreDossiers: 18,
    statut: "actif",
    dateCreation: "2023-03-12",
    contacts: [
      { nom: "Marie Petit", poste: "Directrice Régionale", email: "m.petit@groupama.fr" },
      { nom: "Jean Leroy", poste: "Expert Sinistres", email: "j.leroy@groupama.fr" }
    ]
  },
  {
    id: 4,
    raisonSociale: "MAIF",
    secteur: "Mutuelle",
    adresse: "200 Avenue Salvador Allende, 79000 Niort",
    telephone: "05 49 73 73 73",
    email: "contact@maif.fr",
    nombreDossiers: 27,
    statut: "actif",
    dateCreation: "2023-04-20",
    contacts: []
  },
  {
    id: 5,
    raisonSociale: "Matmut",
    secteur: "Mutuelle",
    adresse: "66 Rue de Sotteville, 76100 Rouen",
    telephone: "02 35 03 68 68",
    email: "info@matmut.fr",
    nombreDossiers: 8,
    statut: "actif",
    dateCreation: "2023-06-15",
    contacts: []
  },
  {
    id: 6,
    raisonSociale: "Crédit Agricole Assurances",
    secteur: "Banque-Assurance",
    adresse: "16-18 Boulevard de Vaugirard, 75015 Paris",
    telephone: "01 57 72 00 00",
    email: "contact@ca-assurances.fr",
    nombreDossiers: 12,
    statut: "actif",
    dateCreation: "2023-08-10",
    contacts: []
  }
];

// Liste des enquêteurs (version complète)
export const enqueteursData = [
  { 
    id: 1, 
    nom: "Dupont",
    prenom: "Marie", 
    email: "m.dupont@provelliance.fr",
    telephone: "06 11 22 33 44",
    adresse: "45 Avenue des Tilleuls, 75012 Paris",
    codePostal: "75012",
    ville: "Paris",
    formeJuridique: "EURL",
    numeroCertification: "CERT-2023-001",
    references: "Experte en sinistres automobiles et habitation. Plus de 10 ans d'expérience dans le secteur des assurances. A traité plus de 500 dossiers avec un taux de satisfaction client de 98%. Spécialisée dans les sinistres complexes et les expertises contradictoires.",
    compteActif: true,
    dateCreation: "2023-01-15",
    derniereModification: "2024-03-20",
    nombreDossiers: 28,
    dossiersEnCours: 3,
    aggrements: [
      {
        id: 1,
        nom: "Agrément Expert Auto",
        typeFichier: "PDF",
        taille: "1.2 MB",
        dateValidite: "2025-12-31",
        dateAjout: "2023-01-15"
      },
      {
        id: 2,
        nom: "Certification Habitation",
        typeFichier: "PDF",
        taille: "890 KB",
        dateValidite: "2025-06-30",
        dateAjout: "2023-02-10"
      }
    ]
  },
  { 
    id: 2, 
    nom: "Moreau",
    prenom: "Pierre", 
    email: "p.moreau@provelliance.fr",
    telephone: "06 22 33 44 55",
    adresse: "12 Rue du Commerce, 69003 Lyon",
    codePostal: "69003",
    ville: "Lyon",
    formeJuridique: "SAS",
    numeroCertification: "CERT-2023-002",
    references: "Expert judiciaire près la Cour d'Appel de Lyon. Spécialisé dans les sinistres professionnels et les expertises industrielles. Formation continue en évaluation des dommages corporels.",
    compteActif: true,
    dateCreation: "2023-02-08",
    derniereModification: "2024-03-18",
    nombreDossiers: 42,
    dossiersEnCours: 5,
    aggrements: [
      {
        id: 1,
        nom: "Agrément Expert Professionnel",
        typeFichier: "PDF",
        taille: "1.5 MB",
        dateValidite: "2026-03-15",
        dateAjout: "2023-02-08"
      },
      {
        id: 2,
        nom: "Certification Incendie",
        typeFichier: "PDF",
        taille: "720 KB",
        dateValidite: "2024-12-31",
        dateAjout: "2023-03-20"
      },
      {
        id: 3,
        nom: "Agrément Dommages Corporels",
        typeFichier: "PDF",
        taille: "950 KB",
        dateValidite: "2025-09-30",
        dateAjout: "2023-06-15"
      }
    ]
  },
  { 
    id: 3, 
    nom: "Martin",
    prenom: "Jean", 
    email: "j.martin@provelliance.fr",
    telephone: "06 33 44 55 66",
    adresse: "8 Boulevard Haussmann, 13001 Marseille",
    codePostal: "13001",
    ville: "Marseille",
    formeJuridique: "Auto-entrepreneur",
    numeroCertification: "CERT-2023-003",
    references: "Expert généraliste avec une solide expérience dans les sinistres habitation. Reconnu pour sa rapidité d'intervention et la qualité de ses rapports. Membre actif de la Chambre des Experts en Assurances.",
    compteActif: true,
    dateCreation: "2023-04-20",
    derniereModification: "2024-03-15",
    nombreDossiers: 35,
    dossiersEnCours: 4,
    aggrements: [
      {
        id: 1,
        nom: "Agrément Expert Généraliste",
        typeFichier: "PDF",
        taille: "1.1 MB",
        dateValidite: "2025-04-30",
        dateAjout: "2023-04-20"
      }
    ]
  },
  { 
    id: 4, 
    nom: "Bernard",
    prenom: "Sophie", 
    email: "s.bernard@provelliance.fr",
    telephone: "06 44 55 66 77",
    adresse: "22 Rue de la République, 33000 Bordeaux",
    codePostal: "33000",
    ville: "Bordeaux",
    formeJuridique: "SASU",
    numeroCertification: "CERT-2023-004",
    references: "Experte spécialisée en sinistres vie et dommages corporels. Diplômée en médecine légale. Intervient régulièrement dans les cas d'invalidité et d'incapacité temporaire.",
    compteActif: true,
    dateCreation: "2023-06-10",
    derniereModification: "2024-03-22",
    nombreDossiers: 18,
    dossiersEnCours: 2,
    aggrements: [
      {
        id: 1,
        nom: "Agrément Sinistres Vie",
        typeFichier: "PDF",
        taille: "1.3 MB",
        dateValidite: "2026-06-30",
        dateAjout: "2023-06-10"
      },
      {
        id: 2,
        nom: "Certification Médicale",
        typeFichier: "PDF",
        taille: "2.1 MB",
        dateValidite: "2027-12-31",
        dateAjout: "2023-07-05"
      }
    ]
  },
  { 
    id: 5, 
    nom: "Petit",
    prenom: "Thomas", 
    email: "t.petit@provelliance.fr",
    telephone: "06 55 66 77 88",
    adresse: "15 Avenue Jean Jaurès, 59000 Lille",
    codePostal: "59000",
    ville: "Lille",
    formeJuridique: "EURL",
    numeroCertification: "CERT-2024-001",
    references: "Nouvel expert en assurances. Formation complète en expertise automobile et habitation. Actuellement en phase d'accompagnement et de montée en compétences.",
    compteActif: false,
    dateCreation: "2024-01-10",
    derniereModification: "2024-02-28",
    nombreDossiers: 5,
    dossiersEnCours: 1,
    aggrements: []
  }
];

// Types et natures de sinistres
export const typesSinistres = [
  "Sinistre Auto",
  "Sinistre Habitation", 
  "Sinistre Professionnel",
  "Sinistre Vie"
];

export const naturesSinistres = {
  "Sinistre Auto": ["Collision", "Vol véhicule", "Bris de glace", "Incendie", "Vandalisme"],
  "Sinistre Habitation": ["Dégât des eaux", "Incendie", "Vol", "Bris de glace", "Catastrophe naturelle"],
  "Sinistre Professionnel": ["Vol", "Incendie", "Dégât des eaux", "Responsabilité civile", "Perte d'exploitation"],
  "Sinistre Vie": ["Décès", "Invalidité", "Incapacité temporaire"]
};

// Liste des dossiers
export const dossiersData = [
  {
    id: 1,
    numero: "DOS-2024-001",
    reference: "REF-CLIENT-1245",
    client: "AXA Assurances",
    clientId: 1,
    assure: {
      type: "particulier",
      nom: "Dupont",
      prenom: "Jean",
      dateNaissance: "1985-05-15",
      lieuNaissance: "Paris, France",
      adresse: "15 rue de la Paix, 75001 Paris",
      telephone: "06 12 34 56 78",
      email: "j.dupont@email.fr"
    },
    tiers: {
      type: "societe",
      raisonSociale: "Transport Express SARL",
      siren: "123456789",
      siret: "12345678900012",
      adresse: "25 Avenue des Champs, 92100 Boulogne",
      telephone: "01 45 67 89 00",
      email: "contact@transport-express.fr"
    },
    sinistre: {
      type: "Sinistre Auto",
      nature: "Collision",
      date: "2024-02-28",
      heure: "14:30",
      lieu: "Carrefour République, Paris 15ème",
      description: "Collision entre deux véhicules à un carrefour. Le véhicule assuré circulait sur l'avenue principale lorsqu'un autre véhicule a grillé le feu rouge."
    },
    typeSinistre: "Sinistre Auto",
    natureSinistre: "Collision",
    dateCreation: "2024-03-01",
    dateAttribution: "2024-03-01",
    dateSinistre: "2024-02-28",
    lieu: "Paris 15ème",
    enqueteur: "Marie Dupont",
    enqueteurId: 1,
    enqueteurData: {
      id: 1,
      nom: "Marie Dupont",
      email: "m.dupont@provelliance.fr",
      telephone: "06 11 22 33 44"
    },
    statut: "en_cours",
    priorite: "normale",
    montantEstime: 15000,
    description: "Collision entre deux véhicules à un carrefour",
    documentsTransmis: [
      { id: 1, nom: "Lettre de mission", type: "Lettre de mission", typeFichier: "PDF", taille: "850 KB", date: "2024-03-01", obligatoire: true },
      { id: 2, nom: "Attestation de mission", type: "Attestation de mission", typeFichier: "PDF", taille: "620 KB", date: "2024-03-01", obligatoire: true },
      { id: 3, nom: "Constat amiable", type: "Constat amiable", typeFichier: "PDF", taille: "2.1 MB", date: "2024-03-01", obligatoire: false },
      { id: 4, nom: "Photos véhicule", type: "Photos", typeFichier: "ZIP", taille: "8.5 MB", date: "2024-03-01", obligatoire: false },
      { id: 5, nom: "Devis garage", type: "Devis", typeFichier: "PDF", taille: "1.2 MB", date: "2024-03-02", obligatoire: false }
    ],
    interactions: [
      {
        id: 1,
        type: "creation",
        auteur: "Système",
        date: "2024-03-01T09:00:00",
        contenu: "Dossier créé et attribué à Marie Dupont",
        pieceJointe: null
      },
      {
        id: 2,
        type: "commentaire",
        auteur: "Marie Dupont",
        date: "2024-03-01T10:30:00",
        contenu: "Dossier pris en charge. Rendez-vous prévu avec l'assuré demain à 14h pour inspection du véhicule.",
        pieceJointe: null
      },
      {
        id: 3,
        type: "document",
        auteur: "Marie Dupont", 
        date: "2024-03-02T16:45:00",
        contenu: "Ajout des photos de l'expertise véhicule",
        pieceJointe: {
          nom: "Photos_expertise_vehicule.zip",
          taille: "12.3 MB"
        }
      },
      {
        id: 4,
        type: "commentaire",
        auteur: "Admin User",
        date: "2024-03-03T11:20:00",
        contenu: "Le client demande un retour sur l'estimation des réparations.",
        pieceJointe: null
      }
    ]
  },
  {
    id: 2,
    numero: "DOS-2024-002",
    reference: "REF-CLIENT-6498",
    client: "Allianz France",
    clientId: 2,
    assure: {
      type: "particulier",
      nom: "Martin",
      prenom: "Sophie",
      telephone: "06 87 65 43 21",
      email: "s.martin@email.fr"
    },
    tiers: null,
    sinistre: {
      type: "Sinistre Habitation",
      nature: "Dégât des eaux",
      date: "2024-03-03",
      lieu: "15 rue Victor Hugo, Lyon 3ème",
      description: "Fuite de canalisation causant des dégâts importants dans l'appartement"
    },
    typeSinistre: "Sinistre Habitation",
    natureSinistre: "Dégât des eaux",
    dateCreation: "2024-03-05",
    dateSinistre: "2024-03-03",
    dateAttribution: "2024-03-05",
    lieu: "Lyon 3ème",
    enqueteur: "Pierre Moreau",
    enqueteurId: 2,
    enqueteurData: {
      id: 2,
      nom: "Pierre Moreau",
      email: "p.moreau@provelliance.fr",
      telephone: "06 22 33 44 55"
    },
    statut: "en_cours",
    priorite: "haute",
    montantEstime: 8500,
    description: "Fuite de canalisation causant des dégâts importants",
    documentsTransmis: [
      { id: 1, nom: "Lettre de mission", type: "Lettre de mission", typeFichier: "PDF", taille: "820 KB", date: "2024-03-05", obligatoire: true },
      { id: 2, nom: "Attestation de mission", type: "Attestation de mission", typeFichier: "PDF", taille: "590 KB", date: "2024-03-05", obligatoire: true },
      { id: 3, nom: "Déclaration sinistre", type: "Autre", typeFichier: "PDF", taille: "1.5 MB", date: "2024-03-05", obligatoire: false },
      { id: 4, nom: "Photos dégâts", type: "Photos", typeFichier: "ZIP", taille: "6.2 MB", date: "2024-03-06", obligatoire: false }
    ]
  },
  {
    id: 3,
    numero: "DOS-2024-003",
    reference: "REF-CLIENT-6951",
    client: "Groupama",
    clientId: 3,
    assure: {
      type: "particulier",
      nom: "Rousseau",
      prenom: "Paul",
      telephone: "06 11 22 33 44"
    },
    tiers: null,
    typeSinistre: "Sinistre Professionnel",
    natureSinistre: "Vol",
    dateCreation: "2024-03-10",
    dateSinistre: "2024-03-08",
    lieu: "Marseille",
    enqueteur: null,
    enqueteurId: null,
    statut: "nouveau",
    priorite: "haute",
    montantEstime: 25000,
    description: "Vol de matériel informatique dans les locaux professionnels",
    documentsTransmis: []
  },
  {
    id: 4,
    numero: "DOS-2024-004",
    reference: "REF-CLIENT-7946",
    client: "MAIF",
    clientId: 3,
    assure: {
      type: "particulier",
      nom: "Bernard",
      prenom: "Julie",
      telephone: "06 11 22 33 44"
    },
    tiers: null,
    typeSinistre: "Sinistre Professionnel",
    natureSinistre: "Vol",
    dateCreation: "2024-03-10",
    dateSinistre: "2024-03-08",
    lieu: "Marseille",
    enqueteur: "Pierre Moreau",
    enqueteurId: 2,
    enqueteurData: {
      id: 2,
      nom: "Pierre Moreau",
      email: "p.moreau@provelliance.fr",
      telephone: "06 22 33 44 55"
    },
    statut: "refuse",
    priorite: "haute",
    montantEstime: 25000,
    description: "Vol de matériel informatique dans les locaux professionnels",
    documentsTransmis: []
  }

];

// Détails client (pour la page de détail)
export const clientDetailData = {
  1: clientsData[0]
};

// Détails dossier (pour la page de détail)
export const dossierDetailData = {
  1: dossiersData[0],
  2: {
    ...dossiersData[1],
    constats: [
      {
        id: 1,
        titre: "Visite initiale",
        type: "visite_initiale",
        date: "2024-03-06T10:00:00",
        description: "Première visite sur les lieux. Constat des dégâts causés par la fuite de canalisation dans la salle de bain.",
        observations: "Dégâts importants sur le sol et les murs. Nécessite intervention urgente.",
        photos: [
          { id: 1, nom: "degats_sdb_1.jpg", commentaire: "Vue d'ensemble des dégâts" },
          { id: 2, nom: "degats_sdb_2.jpg", commentaire: "Détail de la fuite" }
        ]
      }
    ],
    client: {
      nom: "Allianz France",
      contact: "Pierre Moreau",
      telephone: "01 44 86 20 00"
    },
    avancement: 65
  },
  3: dossiersData[2],
  // Dossiers enquêteur
  5: {
    id: 5,
    numero: "DOS-2024-005",
    reference: "REF-CLIENT-5420",
    client: {
      nom: "AXA Assurances",
      contact: "Martin Dubois",
      telephone: "01 40 75 48 48"
    },
    assure: {
      type: "particulier",
      nom: "Lefebvre",
      prenom: "Antoine",
      dateNaissance: "1990-03-15",
      lieuNaissance: "Paris, France",
      adresse: "12 rue de Vaugirard, 75006 Paris",
      telephone: "06 22 33 44 55",
      email: "a.lefebvre@email.fr"
    },
    tiers: null,
    sinistre: {
      type: "Sinistre Auto",
      nature: "Bris de glace",
      date: "2024-02-27",
      heure: "15:45",
      lieu: "Autoroute A6, Sens Paris-Lyon",
      description: "Impact de pierre sur pare-brise lors d'un trajet autoroutier"
    },
    typeSinistre: "Sinistre Auto",
    natureSinistre: "Bris de glace",
    dateCreation: "2024-02-28",
    dateSinistre: "2024-02-27",
    dateAcceptation: "2024-02-28T10:00:00",
    dateCloture: "2024-03-08",
    lieu: "Autoroute A6, Sens Paris-Lyon",
    statut: "cloture",
    priorite: "normale",
    montantEstime: 450,
    description: "Impact de pierre sur pare-brise",
    avancement: 100,
    constats: [
      {
        id: 1,
        titre: "Constat d'expertise pare-brise",
        type: "visite_initiale",
        date: "2024-02-29T14:00:00",
        description: "Expertise réalisée au garage. Impact de 3cm de diamètre sur le pare-brise côté conducteur.",
        observations: "Remplacement du pare-brise nécessaire. Devis du garage conforme au prix marché.",
        photos: [
          { id: 1, nom: "parebrise_impact.jpg", commentaire: "Impact principal" }
        ]
      }
    ],
    documentsTransmis: [
      { id: 1, nom: "Lettre de mission", type: "Lettre de mission", typeFichier: "PDF", taille: "850 KB", date: "2024-02-28", obligatoire: true },
      { id: 2, nom: "Devis garage", type: "Devis", typeFichier: "PDF", taille: "520 KB", date: "2024-02-29", obligatoire: false }
    ]
  },
  7: {
    id: 7,
    numero: "DOS-2024-007",
    reference: "REF-CLIENT-6951",
    client: {
      nom: "AXA Assurances",
      contact: "Martin Dubois",
      telephone: "01 40 75 48 48"
    },
    assure: {
      type: "particulier",
      nom: "Dubois",
      prenom: "Pierre",
      dateNaissance: "1978-11-20",
      lieuNaissance: "Bordeaux, France",
      adresse: "56 Cours de l'Intendance, 33000 Bordeaux",
      telephone: "06 44 33 22 11",
      email: "p.dubois@email.fr"
    },
    tiers: {
      type: "particulier",
      nom: "Leroux",
      prenom: "Marie",
      adresse: "45 Avenue Thiers, 33100 Bordeaux",
      telephone: "06 55 66 77 88",
      email: "m.leroux@email.fr"
    },
    sinistre: {
      type: "Sinistre Auto",
      nature: "Collision",
      date: "2024-03-17",
      heure: "16:20",
      lieu: "Parking Carrefour, Bordeaux",
      description: "Collision en marche arrière sur parking. Le véhicule assuré a heurté un autre véhicule lors d'une manœuvre."
    },
    typeSinistre: "Sinistre Auto",
    natureSinistre: "Collision",
    dateCreation: "2024-03-18",
    dateSinistre: "2024-03-17",
    dateAcceptation: "2024-03-18T11:00:00",
    lieu: "Parking Carrefour, Bordeaux",
    statut: "en_cours",
    priorite: "normale",
    montantEstime: 3200,
    description: "Collision en marche arrière sur parking",
    avancement: 35,
    constats: [
      {
        id: 1,
        titre: "Visite initiale - Constat des dégâts",
        type: "visite_initiale",
        date: "2024-03-19T14:00:00",
        description: "Rencontre avec l'assuré et inspection des deux véhicules. Dégâts au niveau du pare-chocs arrière du véhicule assuré et avant du véhicule tiers.",
        observations: "Dégâts mineurs. Réparation estimée à environ 3200€. Photos prises des deux véhicules.",
        photos: [
          { id: 1, nom: "vehicule_assure_arriere.jpg", commentaire: "Pare-chocs arrière endommagé" },
          { id: 2, nom: "vehicule_tiers_avant.jpg", commentaire: "Avant du véhicule tiers" }
        ]
      }
    ],
    documentsTransmis: [
      { id: 1, nom: "Lettre de mission", type: "Lettre de mission", typeFichier: "PDF", taille: "850 KB", date: "2024-03-18", obligatoire: true },
      { id: 2, nom: "Attestation de mission", type: "Attestation de mission", typeFichier: "PDF", taille: "620 KB", date: "2024-03-18", obligatoire: true },
      { id: 3, nom: "Constat amiable", type: "Constat amiable", typeFichier: "PDF", taille: "1.8 MB", date: "2024-03-18", obligatoire: false }
    ]
  },
  8: {
    id: 8,
    numero: "DOS-2024-008",
    reference: "REF-CLIENT-7100",
    client: {
      nom: "MAIF",
      contact: "Service Sinistres",
      telephone: "05 49 73 73 73"
    },
    assure: {
      type: "particulier",
      nom: "Bernard",
      prenom: "Julie",
      dateNaissance: "1985-07-10",
      lieuNaissance: "Paris, France",
      adresse: "8 Boulevard Haussmann, 75009 Paris",
      telephone: "06 99 88 77 66",
      email: "j.bernard@email.fr"
    },
    tiers: null,
    sinistre: {
      type: "Sinistre Habitation",
      nature: "Bris de glace",
      date: "2024-03-14",
      heure: "03:30",
      lieu: "8 Boulevard Haussmann, Paris 9ème",
      description: "Bris de grande baie vitrée suite à tempête avec vents violents"
    },
    typeSinistre: "Sinistre Habitation",
    natureSinistre: "Bris de glace",
    dateCreation: "2024-03-15",
    dateSinistre: "2024-03-14",
    dateAcceptation: "2024-03-15T09:30:00",
    lieu: "8 Boulevard Haussmann, Paris 9ème",
    statut: "en_cours",
    priorite: "basse",
    montantEstime: 1200,
    description: "Bris de grande baie vitrée suite à tempête",
    avancement: 80,
    constats: [
      {
        id: 1,
        titre: "Expertise initiale",
        type: "visite_initiale",
        date: "2024-03-15T14:00:00",
        description: "Visite du logement. Baie vitrée du salon complètement brisée. Mesures prises pour devis de remplacement.",
        observations: "Intervention urgente réalisée par vitrier pour sécurisation. Devis de remplacement conforme.",
        photos: [
          { id: 1, nom: "baie_vitree_brisee.jpg", commentaire: "Baie vitrée endommagée" },
          { id: 2, nom: "mesures_baie.jpg", commentaire: "Mesures pour devis" }
        ]
      },
      {
        id: 2,
        titre: "Suivi - Réception devis vitrier",
        type: "suivi",
        date: "2024-03-16T10:00:00",
        description: "Réception du devis du vitrier pour le remplacement de la baie vitrée.",
        observations: "Devis validé. Intervention prévue la semaine prochaine.",
        photos: []
      }
    ],
    documentsTransmis: [
      { id: 1, nom: "Lettre de mission", type: "Lettre de mission", typeFichier: "PDF", taille: "850 KB", date: "2024-03-15", obligatoire: true },
      { id: 2, nom: "Attestation de mission", type: "Attestation de mission", typeFichier: "PDF", taille: "620 KB", date: "2024-03-15", obligatoire: true },
      { id: 3, nom: "Devis vitrier", type: "Devis", typeFichier: "PDF", taille: "980 KB", date: "2024-03-16", obligatoire: false }
    ]
  },
  10: {
    id: 10,
    numero: "DOS-2024-010",
    reference: "REF-CLIENT-7820",
    client: {
      nom: "AXA Assurances",
      contact: "Martin Dubois",
      telephone: "01 40 75 48 48"
    },
    assure: {
      type: "particulier",
      nom: "Lemoine",
      prenom: "Catherine",
      dateNaissance: "1975-09-22",
      lieuNaissance: "Lyon, France",
      adresse: "25 Avenue Jean Jaurès, 75019 Paris",
      telephone: "06 33 44 55 66",
      email: "c.lemoine@email.fr"
    },
    tiers: null,
    sinistre: {
      type: "Sinistre Habitation",
      nature: "Incendie",
      date: "2024-03-19",
      heure: "19:45",
      lieu: "25 Avenue Jean Jaurès, 75019 Paris",
      description: "Incendie dans la cuisine ayant causé des dégâts importants. Origine : plaque de cuisson restée allumée."
    },
    typeSinistre: "Sinistre Habitation",
    natureSinistre: "Incendie",
    dateCreation: "2024-03-20",
    dateSinistre: "2024-03-19",
    dateAttribution: "2024-03-20T09:00:00",
    lieu: "25 Avenue Jean Jaurès, 75019 Paris",
    statut: "en_attente_acceptation",
    priorite: "haute",
    montantEstime: 45000,
    description: "Incendie dans la cuisine ayant causé des dégâts importants",
    avancement: 0,
    constats: [],
    documentsTransmis: [
      { id: 1, nom: "Lettre de mission", type: "Lettre de mission", typeFichier: "PDF", taille: "850 KB", date: "2024-03-20", obligatoire: true },
      { id: 2, nom: "Rapport pompiers", type: "Rapport", typeFichier: "PDF", taille: "1.2 MB", date: "2024-03-20", obligatoire: false }
    ]
  },
  11: {
    id: 11,
    numero: "DOS-2024-011",
    reference: "REF-CLIENT-7821",
    client: {
      nom: "Groupama",
      contact: "Marie Petit",
      telephone: "01 44 56 77 77"
    },
    assure: {
      type: "particulier",
      nom: "Girard",
      prenom: "Marc",
      dateNaissance: "1982-04-12",
      lieuNaissance: "Marseille, France",
      adresse: "78 Rue de la République, 69002 Lyon",
      telephone: "06 77 88 99 00",
      email: "m.girard@email.fr"
    },
    tiers: null,
    sinistre: {
      type: "Sinistre Auto",
      nature: "Vol véhicule",
      date: "2024-03-18",
      heure: "22:00",
      lieu: "Parking souterrain, 15 rue Pasteur, Lyon",
      description: "Vol de véhicule dans parking souterrain avec effraction de la porte du parking"
    },
    typeSinistre: "Sinistre Auto",
    natureSinistre: "Vol véhicule",
    dateCreation: "2024-03-20",
    dateSinistre: "2024-03-18",
    dateAttribution: "2024-03-20T14:30:00",
    lieu: "Parking souterrain, 15 rue Pasteur, Lyon",
    statut: "en_attente_acceptation",
    priorite: "normale",
    montantEstime: 28000,
    description: "Vol de véhicule dans parking souterrain avec effraction",
    avancement: 0,
    constats: [],
    documentsTransmis: [
      { id: 1, nom: "Lettre de mission", type: "Lettre de mission", typeFichier: "PDF", taille: "850 KB", date: "2024-03-20", obligatoire: true },
      { id: 2, nom: "Dépôt de plainte", type: "Document officiel", typeFichier: "PDF", taille: "750 KB", date: "2024-03-19", obligatoire: false }
    ]
  }
};

// Données pour l'enquêteur
export const enqueteurDashboardData = {
  nom: "Marie Dupont",
  email: "m.dupont@provelliance.fr",
  telephone: "06 11 22 33 44",
  // Dossiers en attente d'acceptation
  dossiersEnAttente: [
    {
      id: 10,
      numero: "DOS-2024-010",
      reference: "REF-CLIENT-7820",
      client: "AXA Assurances",
      clientId: 1,
      assure: {
        nom: "Lemoine",
        prenom: "Catherine",
        telephone: "06 33 44 55 66",
        email: "c.lemoine@email.fr"
      },
      typeSinistre: "Sinistre Habitation",
      natureSinistre: "Incendie",
      dateCreation: "2024-03-20",
      dateSinistre: "2024-03-19",
      dateAttribution: "2024-03-20T09:00:00",
      lieu: "25 Avenue Jean Jaurès, 75019 Paris",
      statut: "en_attente_acceptation",
      priorite: "haute",
      montantEstime: 45000,
      description: "Incendie dans la cuisine ayant causé des dégâts importants",
      derniereInteraction: "2024-03-20T09:00:00",
      prochainRendezVous: null,
      avancement: 0
    },
    {
      id: 11,
      numero: "DOS-2024-011",
      reference: "REF-CLIENT-7821",
      client: "Groupama",
      clientId: 3,
      assure: {
        nom: "Girard",
        prenom: "Marc",
        telephone: "06 77 88 99 00",
        email: "m.girard@email.fr"
      },
      typeSinistre: "Sinistre Auto",
      natureSinistre: "Vol véhicule",
      dateCreation: "2024-03-20",
      dateSinistre: "2024-03-18",
      dateAttribution: "2024-03-20T14:30:00",
      lieu: "Parking souterrain, 15 rue Pasteur, Lyon",
      statut: "en_attente_acceptation",
      priorite: "normale",
      montantEstime: 28000,
      description: "Vol de véhicule dans parking souterrain avec effraction",
      derniereInteraction: "2024-03-20T14:30:00",
      prochainRendezVous: null,
      avancement: 0
    }
  ],
  // Dossiers acceptés (en cours)
  dossiersEnCours: [
    {
      id: 2,
      numero: "DOS-2024-002",
      reference: "REF-CLIENT-6498",
      client: "Allianz France",
      clientId: 2,
      assure: {
        nom: "Martin",
        prenom: "Sophie",
        telephone: "06 87 65 43 21",
        email: "s.martin@email.fr"
      },
      typeSinistre: "Sinistre Habitation",
      natureSinistre: "Dégât des eaux",
      dateCreation: "2024-03-05",
      dateSinistre: "2024-03-03",
      dateAcceptation: "2024-03-05T10:00:00",
      lieu: "15 rue Victor Hugo, Lyon 3ème",
      statut: "en_cours",
      priorite: "haute",
      montantEstime: 8500,
      description: "Fuite de canalisation causant des dégâts importants dans l'appartement",
      derniereInteraction: "2024-03-12T14:30:00",
      prochainRendezVous: "2024-03-22T10:00:00",
      avancement: 65
    },
    {
      id: 7,
      numero: "DOS-2024-007",
      reference: "REF-CLIENT-6951",
      client: "AXA Assurances",
      clientId: 1,
      assure: {
        nom: "Dubois",
        prenom: "Pierre",
        telephone: "06 44 33 22 11",
        email: "p.dubois@email.fr"
      },
      typeSinistre: "Sinistre Auto",
      natureSinistre: "Collision",
      dateCreation: "2024-03-18",
      dateSinistre: "2024-03-17",
      dateAcceptation: "2024-03-18T11:00:00",
      lieu: "Parking Carrefour, Bordeaux",
      statut: "en_cours",
      priorite: "normale",
      montantEstime: 3200,
      description: "Collision en marche arrière sur parking",
      derniereInteraction: "2024-03-18T09:00:00",
      prochainRendezVous: "2024-03-21T14:00:00",
      avancement: 35
    },
    {
      id: 8,
      numero: "DOS-2024-008",
      reference: "REF-CLIENT-7100",
      client: "MAIF",
      clientId: 4,
      assure: {
        nom: "Bernard",
        prenom: "Julie",
        telephone: "06 99 88 77 66",
        email: "j.bernard@email.fr"
      },
      typeSinistre: "Sinistre Habitation",
      natureSinistre: "Bris de glace",
      dateCreation: "2024-03-15",
      dateSinistre: "2024-03-14",
      dateAcceptation: "2024-03-15T09:30:00",
      lieu: "8 Boulevard Haussmann, Paris 9ème",
      statut: "en_cours",
      priorite: "basse",
      montantEstime: 1200,
      description: "Bris de grande baie vitrée suite à tempête",
      derniereInteraction: "2024-03-16T15:00:00",
      prochainRendezVous: null,
      avancement: 80
    }
  ],
  // Dossiers terminés
  dossiersTermines: [
    {
      id: 5,
      numero: "DOS-2024-005",
      reference: "REF-CLIENT-5420",
      client: "AXA Assurances",
      clientId: 1,
      assure: {
        nom: "Lefebvre",
        prenom: "Antoine",
        telephone: "06 22 33 44 55",
        email: "a.lefebvre@email.fr"
      },
      typeSinistre: "Sinistre Auto",
      natureSinistre: "Bris de glace",
      dateCreation: "2024-02-28",
      dateSinistre: "2024-02-27",
      dateAcceptation: "2024-02-28T10:00:00",
      dateCloture: "2024-03-08",
      lieu: "Autoroute A6, Sens Paris-Lyon",
      statut: "cloture",
      priorite: "normale",
      montantEstime: 450,
      description: "Impact de pierre sur pare-brise",
      derniereInteraction: "2024-03-08T16:00:00",
      prochainRendezVous: null,
      avancement: 100
    },
    {
      id: 6,
      numero: "DOS-2024-006",
      reference: "REF-CLIENT-5890",
      client: "Allianz France",
      clientId: 2,
      assure: {
        nom: "Rousseau",
        prenom: "Marie",
        telephone: "06 55 66 77 88",
        email: "m.rousseau@email.fr"
      },
      typeSinistre: "Sinistre Habitation",
      natureSinistre: "Dégât des eaux",
      dateCreation: "2024-02-20",
      dateSinistre: "2024-02-19",
      dateAcceptation: "2024-02-20T14:00:00",
      dateCloture: "2024-03-05",
      lieu: "45 Rue de la République, Marseille",
      statut: "cloture",
      priorite: "haute",
      montantEstime: 5600,
      description: "Rupture de canalisation dans salle de bain",
      derniereInteraction: "2024-03-05T11:30:00",
      prochainRendezVous: null,
      avancement: 100
    }
  ]
};

// Statistiques
export const statisticsData = {
  periodes: {
    jour: {
      label: "Aujourd'hui",
      dossiersCreees: 3,
      dossiersOuverts: 2,
      dossiersEnCours: 5,
      dossiersCloturs: 1
    },
    semaine: {
      label: "Cette semaine",
      dossiersCreees: 12,
      dossiersOuverts: 8,
      dossiersEnCours: 15,
      dossiersCloturs: 5
    },
    mois: {
      label: "Ce mois",
      dossiersCreees: 45,
      dossiersOuverts: 18,
      dossiersEnCours: 35,
      dossiersCloturs: 22
    },
    trimestre: {
      label: "Ce trimestre",
      dossiersCreees: 135,
      dossiersOuverts: 45,
      dossiersEnCours: 98,
      dossiersCloturs: 67
    },
    annee: {
      label: "Cette année",
      dossiersCreees: 520,
      dossiersOuverts: 156,
      dossiersEnCours: 385,
      dossiersCloturs: 248
    }
  },
  repartitionTypes: {
    "Sinistre Auto": 125,
    "Sinistre Habitation": 98,
    "Sinistre Professionnel": 76,
    "Dégâts des Eaux": 54,
    "Vol et Vandalisme": 42,
    "Incendie": 28,
    "Catastrophe Naturelle": 15
  },
  evolutionMensuelle: [
    { mois: "Oct", crees: 42, cloturs: 38 },
    { mois: "Nov", crees: 48, cloturs: 45 },
    { mois: "Dec", crees: 52, cloturs: 48 },
    { mois: "Jan", crees: 45, cloturs: 42 },
    { mois: "Fev", crees: 50, cloturs: 47 },
    { mois: "Mar", crees: 45, cloturs: 22 }
  ],
  performanceClients: [
    { client: "AXA Assurances", dossiers: 45, satisfaction: 4.5 },
    { client: "Allianz France", dossiers: 32, satisfaction: 4.2 },
    { client: "Groupama", dossiers: 28, satisfaction: 4.8 },
    { client: "MAIF", dossiers: 25, satisfaction: 4.6 },
    { client: "Generali", dossiers: 22, satisfaction: 4.3 }
  ],
  enqueteurs: [
    {
      id: 1,
      nom: "Jean Martin",
      specialites: ["Auto", "Habitation"],
      dossiersAttribues: 28,
      dossiersRefuses: 2,
      dossiersEnCours: 12,
      dossiersCloturs: 16,
      dureeTraitementMoyenne: 8,
      tauxReussite: 95
    },
    {
      id: 2,
      nom: "Marie Dupont",
      specialites: ["Habitation", "Dégâts des eaux"],
      dossiersAttribues: 32,
      dossiersRefuses: 1,
      dossiersEnCours: 15,
      dossiersCloturs: 17,
      dureeTraitementMoyenne: 7,
      tauxReussite: 97
    },
    {
      id: 3,
      nom: "Pierre Moreau",
      specialites: ["Professionnel", "Incendie"],
      dossiersAttribues: 25,
      dossiersRefuses: 3,
      dossiersEnCours: 10,
      dossiersCloturs: 15,
      dureeTraitementMoyenne: 9,
      tauxReussite: 92
    }
  ]
};

